import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-418d3b62")

_pushScopeId("data-v-418d3b62")
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "section"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "title diplay-inline" }, "CTF List", -1)
const _hoisted_5 = { class: "field has-addons diplay-inline float-right" }
const _hoisted_6 = { class: "control" }
const _hoisted_7 = {
  key: 0,
  class: "subtitle mt-4"
}
const _hoisted_8 = {
  key: 1,
  class: "columns is-multiline"
}
const _hoisted_9 = {
  key: 2,
  class: ""
}
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Searching for ")
const _hoisted_11 = { class: "has-text-white" }
const _hoisted_12 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" We’ve found 0 results for your search term. ")
const _hoisted_14 = {
  key: 3,
  class: "subtitle mt-4"
}
const _hoisted_15 = {
  key: 4,
  class: "columns is-multiline"
}
const _hoisted_16 = {
  key: 5,
  class: "subtitle mt-4"
}
const _hoisted_17 = {
  key: 6,
  class: "columns is-multiline"
}
const _hoisted_18 = {
  key: 7,
  class: "subtitle mt-4"
}
const _hoisted_19 = {
  key: 8,
  class: "columns is-multiline"
}
const _hoisted_20 = {
  key: 9,
  class: "modal-background"
}
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "modal-background" }, null, -1)
const _hoisted_22 = { class: "modal-card width-300" }
const _hoisted_23 = { class: "modal-card-body modal-style" }
const _hoisted_24 = { class: "title is-6 margin-10" }
const _hoisted_25 = /*#__PURE__*/_createVNode("div", { class: "margin-10" }, " Ready to start the guided tour ? ", -1)
const _hoisted_26 = /*#__PURE__*/_createTextVNode("   ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_loader = _resolveComponent("loader")
  const _component_ctf_card = _resolveComponent("ctf-card")
  const _component_popup = _resolveComponent("popup")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode(_component_loader)
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_3, [
          _hoisted_4,
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _withDirectives(_createVNode("input", {
                class: "input is-background-black has-text-white",
                type: "text",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchedCtfs = $event)),
                placeholder: "Search"
              }, null, 512), [
                [_vModelText, _ctx.searchedCtfs]
              ])
            ])
          ]),
          (_ctx.searchedCtfs != '')
            ? (_openBlock(), _createBlock("div", _hoisted_7, " Search result "))
            : _createCommentVNode("", true),
          (_ctx.searchedCtfs != '')
            ? (_openBlock(), _createBlock("div", _hoisted_8, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.findSearchedCtfs(), ({ id, image, title, url }) => {
                  return (_openBlock(), _createBlock("div", {
                    key: id,
                    class: "column is-one-quarter"
                  }, [
                    _createVNode(_component_ctf_card, {
                      id: id,
                      image: image,
                      title: title,
                      url: url,
                      "data-testid": "ctf-card"
                    }, null, 8, ["id", "image", "title", "url"])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_ctx.searchedCtfs != '' && _ctx.findSearchedCtfs().length == 0)
            ? (_openBlock(), _createBlock("div", _hoisted_9, [
                _hoisted_10,
                _createVNode("strong", _hoisted_11, _toDisplayString(_ctx.searchedCtfs), 1),
                _hoisted_12,
                _hoisted_13
              ]))
            : _createCommentVNode("", true),
          (_ctx.myCtfs.length > 0 && _ctx.searchedCtfs == '')
            ? (_openBlock(), _createBlock("div", _hoisted_14, " My CTFs "))
            : _createCommentVNode("", true),
          (_ctx.myCtfs.length > 0 && _ctx.searchedCtfs == '')
            ? (_openBlock(), _createBlock("div", _hoisted_15, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.myCtfs, ({ id, image, title, url }) => {
                  return (_openBlock(), _createBlock("div", {
                    key: id,
                    class: "column is-one-quarter"
                  }, [
                    _createVNode(_component_ctf_card, {
                      id: id,
                      image: image,
                      title: title,
                      url: url,
                      "data-testid": "ctf-card"
                    }, null, 8, ["id", "image", "title", "url"])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_ctx.mostPopularCtfs.length > 0 && _ctx.searchedCtfs == '')
            ? (_openBlock(), _createBlock("div", _hoisted_16, " Most Popular 🔥 "))
            : _createCommentVNode("", true),
          (_ctx.mostPopularCtfs.length > 0 && _ctx.searchedCtfs == '')
            ? (_openBlock(), _createBlock("div", _hoisted_17, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.mostPopularCtfs, ({ id, image, title, url }, index) => {
                  return (_openBlock(), _createBlock("div", {
                    key: id,
                    id: `scrollTo-${index}`,
                    class: "column is-one-quarter popup",
                    style: { zIndex: index == 1 ? 1 : 0 }
                  }, [
                    _createVNode(_component_ctf_card, {
                      id: id,
                      image: image,
                      title: title,
                      url: url,
                      "data-testid": "ctf-card"
                    }, null, 8, ["id", "image", "title", "url"]),
                    (index == 1)
                      ? (_openBlock(), _createBlock(_component_popup, {
                          key: 0,
                          step: 0,
                          position: "bottom",
                          offsetY: 3,
                          showPopup: _ctx.currentStep == 0,
                          onNextAction: ($event: any) => (_ctx.nextAction(id))
                        }, null, 8, ["showPopup", "onNextAction"]))
                      : _createCommentVNode("", true)
                  ], 12, ["id"]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_ctx.ctfsToDiscover.length > 0 && _ctx.searchedCtfs == '')
            ? (_openBlock(), _createBlock("div", _hoisted_18, " To Discover "))
            : _createCommentVNode("", true),
          (_ctx.ctfsToDiscover.length > 0 && _ctx.searchedCtfs == '')
            ? (_openBlock(), _createBlock("div", _hoisted_19, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.ctfsToDiscover, ({ id, image, title, url }) => {
                  return (_openBlock(), _createBlock("div", {
                    key: id,
                    class: "column is-one-quarter"
                  }, [
                    _createVNode(_component_ctf_card, {
                      id: id,
                      image: image,
                      title: title,
                      url: url,
                      "data-testid": "ctf-card"
                    }, null, 8, ["id", "image", "title", "url"])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_ctx.currentStep == 0)
            ? (_openBlock(), _createBlock("div", _hoisted_20))
            : _createCommentVNode("", true)
        ])),
    _createVNode("div", {
      class: `modal ${_ctx.showModal ? 'is-active' : ''}`
    }, [
      _hoisted_21,
      _createVNode("div", _hoisted_22, [
        _createVNode("section", _hoisted_23, [
          _createVNode("h6", _hoisted_24, "HELLO " + _toDisplayString(_ctx.username), 1),
          _hoisted_25,
          _createVNode("div", null, [
            _createVNode("a", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setStep(false))),
              class: "button is-small is-primary is-outlined",
              "data-testid": "modal-skip-button"
            }, " SKIP TOUR "),
            _hoisted_26,
            _createVNode("a", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setStep(true))),
              class: "button is-small is-background-green no-border",
              "data-testid": "modal-go-button"
            }, " LET’S GO ")
          ])
        ])
      ])
    ], 2)
  ]))
})